import { OnboardingStep, OnboardingStepBarKey, OnboardingStepKey } from './types';
import { safeLocalStorage } from '../../utils/safeLocalStorage';

export const onboardingStepBarTitles: Record<OnboardingStepBarKey, string> = {
  ABOUT_YOU: 'About You',
  DISCOVER_RHYTHM: 'Discover Rhythm',
  GET_SCHEDULE: 'Get Your Schedule',
};

export const onboardingStepBarDescriptions: Record<OnboardingStepBarKey, string> = {
  ABOUT_YOU: 'Tell us about yourself to get personalized insights',
  DISCOVER_RHYTHM: 'Get an overview of your energy to understand why timing matters',
  GET_SCHEDULE: 'Preview how Lifestack plans your day with AI',
};

export const onboardingStepBarSections: OnboardingStepBarKey[] = [
  'ABOUT_YOU',
  'DISCOVER_RHYTHM',
  'GET_SCHEDULE',
];

export const onboardingSteps: OnboardingStep[] = [
  {
    key: 'WELCOME',
    order: 1,
    afterSignIn: false,
  },
  {
    key: 'ENERGY_SITUATION',
    order: 2,
    afterSignIn: false,
  },
  {
    key: 'GET_STARTED',
    order: 3,
    afterSignIn: false,
  },
  {
    key: 'NAME_ENTRY',
    order: 4,
    stepBarKey: 'ABOUT_YOU',
    afterSignIn: true,
    afterPaywall: true,
  },
  {
    key: 'PERSONA_SURVEY',
    order: 5,
    stepBarKey: 'ABOUT_YOU',
    disableToGoBack: true,
    afterSignIn: true,
    afterPaywall: true,
  },
  {
    key: 'MARKETING_SURVEY',
    order: 6,
    stepBarKey: 'ABOUT_YOU',
    afterSignIn: true,
    afterPaywall: true,
  },
  {
    key: 'MANUAL_SLEEP_INPUT',
    order: 7,
    stepBarKey: 'DISCOVER_RHYTHM',
    afterSignIn: true,
    afterPaywall: true,
    disableToGoBack: true,
  },
  {
    key: 'ENERGY_PREDICTION_RESULT',
    order: 8,
    stepBarKey: 'DISCOVER_RHYTHM',
    disableToGoBack: true,
    afterSignIn: true,
    afterPaywall: true,
  },
  {
    key: 'POWER_UP_PLAN',
    order: 9,
    stepBarKey: 'GET_SCHEDULE',
    afterSignIn: true,
    afterPaywall: true,
  },
  {
    key: 'AI_PLAN_PREVIEW',
    order: 10,
    stepBarKey: 'GET_SCHEDULE',
    disableToGoBack: true,
    afterSignIn: true,
    afterPaywall: true,
  },
];

export const getFirstOnboardingStepsAfterPaywall = () => {
  return onboardingSteps.find((step) => step.afterPaywall)?.key;
};

// Persists the last visited onboarding step after the paywall, so a refresh
// or a fresh sign-in resumes where the user left off instead of restarting
// the post-paywall flow from its first step. Steps before the paywall are
// never stored here.
export const ONBOARDING_LAST_STEP_AFTER_PAYWALL_KEY = 'onboarding_last_step_after_paywall';

export const saveLastOnboardingStepAfterPaywall = (stepKey: OnboardingStepKey) => {
  safeLocalStorage.setItem(ONBOARDING_LAST_STEP_AFTER_PAYWALL_KEY, stepKey);
};

export const clearLastOnboardingStepAfterPaywall = () => {
  safeLocalStorage.removeItem(ONBOARDING_LAST_STEP_AFTER_PAYWALL_KEY);
};

export const getLastOnboardingStepAfterPaywall = (): OnboardingStepKey | undefined => {
  const storedKey = safeLocalStorage.getItem(ONBOARDING_LAST_STEP_AFTER_PAYWALL_KEY);
  const step = onboardingSteps.find((step) => step.key === storedKey && step.afterPaywall);
  return step?.key;
};
